import controller from './vd-dropdown-suggestions.controller'
import template from './vd-dropdown-suggestions.html'

export default {
  bindings: {
    source: '<',
    suggestions: '<',
    groups: '<',
    selected: '<',
    allowClear: '<',
    onSelect: '&',
    onCreate: '&',
    lazyLoad: '<?',
    prefill: '<?',
  },
  controller,
  template,
}
